export default {
  "tree.all": "All files",
  "tree.empty": "No files",
  "tree.changes.one": "{{count}} file changed",
  "tree.changes.other": "{{count}} files changed",
  "tab.notFound": "File not found: {{name}}",
  "mobile.title": "Files",
  "mobile.openTabs": "Open files",
  "view.preview": "Preview",
  "view.fit": "Fit",
  "view.source": "Source",
  "view.openInBrowser": "Open in browser",
  "view.fullscreen": "Enter full screen",
  "view.exitFullscreen": "Exit full screen",
  "view.binary": "Binary file · {{size}}",
  "view.table.rows.one": "{{count}} row",
  "view.table.rows.other": "{{count}} rows",
  "view.table.columns.one": "{{count}} column",
  "view.table.columns.other": "{{count}} columns",
  "view.table.truncated": "Showing the first {{shown}} of {{total}} rows.",
  "view.fontSample": "Sphinx of black quartz, judge my vow.",
  "open.in": "Open in",
  "open.ariaLabel": "Open in {{app}}",
  "open.menu": "Open options",
  "open.copyPath": "Copy path",
  "open.app.vscode": "VS Code",
  "open.app.cursor": "Cursor",
  "open.app.zed": "Zed",
  "open.app.textmate": "TextMate",
  "open.app.antigravity": "Antigravity",
  "open.app.terminal": "Terminal",
  "open.app.iterm2": "iTerm2",
  "open.app.ghostty": "Ghostty",
  "open.app.warp": "Warp",
  "open.app.xcode": "Xcode",
  "open.app.androidStudio": "Android Studio",
  "open.app.powershell": "PowerShell",
  "open.app.sublimeText": "Sublime Text",
  selectToOpen: "Select a file to open",
  "open.finder": "Finder",
  "open.fileExplorer": "File Explorer",
  "open.fileManager": "File Manager",
  "command.open": "Open file",
}
